import React, { Component } from "react";
import styles from "./winterMaintenceMapWrapper.module.scss";
import { withWinterMaintence } from "../../../shared/containers/containerWinterMaintence";
import { states } from "../../../reducers/queriesStates";
import Scrollbars from "react-custom-scrollbars-2";
import WinterMaintenceUnitsTable from "./WinterMaintenceUnitsTable";
import ReactToPrint from "react-to-print";
import PrintIcon from "@mui/icons-material/Print";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import ButtonIconWrapper from "../../../shared/items/contols/buttonIconWrapper";

class WinterMaintenceCompaniesInfo extends Component {
  componentRef = null;

  onCompaniesChangeHandler(id) {
    const { winterArea, winterAreasFilter, onSetWinterAreasFilter } = this.props;

    const filter = winterAreasFilter.map((x) => {
      if (x.winterAreaId === winterArea.id) {
        x.companyId = id;
      }

      return x;
    });

    onSetWinterAreasFilter(filter);
  }

  areaBox(area) {
    const { winterAreasFilter } = this.props;

    const winterAreaFilter = winterAreasFilter.filter((x) => {
      return x.winterAreaId === area.id;
    })[0];

    if (winterAreaFilter.parentCompanies.length === 0) {
      return null;
    }

    return (
      <div key={area.id} className={styles.areaContainer}>
        <div>{area.title}</div>
        <div>
          {area.parentCompanies.map((parentCompany) => {
            const isSome = winterAreaFilter.parentCompanies.some((x) => {
              return x === parentCompany.id;
            });

            return isSome ? this.parentCompanyBox(parentCompany, winterAreaFilter) : null;
          })}
        </div>
      </div>
    );
  }

  parentCompanyBox(parentCompany, winterAreaFilter) {
    return (
      <div key={parentCompany.id} className={styles.parentCompanyContainer}>
        <div>{parentCompany.title}</div>
        <div>
          {parentCompany.companies
            .filter((company) => {
              if (winterAreaFilter.companyId !== null && winterAreaFilter.companyId !== company.id) {
                return false;
              }

              return true;
            })
            .map((company) => {
              return this.companyBox(company);
            })}
        </div>
      </div>
    );
  }

  companyBox(company) {
    const { winterWithoutGroupsFilter, winterGroupsFilter, searchTermWinterUnit } = this.props;

    if (company.units.length === 0) {
      return null;
    }

    const isGroupView = (unitGroups, filterGroups) => {
      if (filterGroups.length === 0 || unitGroups.length === 0) return false;

      return unitGroups.some((unitGroup) => {
        return filterGroups.some((x) => {
          return x === unitGroup.id;
        });
      });
    };

    const units = company.units.filter((unit) => {
      if (searchTermWinterUnit.length > 3) {
        return unit.registerNumber !== null && unit.registerNumber.toLowerCase().includes(searchTermWinterUnit);
      }

      const inGroups = unit.groups.length > 0;

      if (isGroupView(unit.groups, winterGroupsFilter)) {
        return true;
      } else if (!inGroups && winterWithoutGroupsFilter) {
        return true;
      }

      return false;
    });

    if (units.length === 0) {
      return null;
    }

    let dumpCount = 0;
    let sandCount = 0;

    units.forEach((unit) => {
      dumpCount += unit.isDumpSensor ? 1 : 0;
      sandCount += unit.isSandSensor ? 1 : 0;
    });

    return (
      <div key={company.id} className={styles.companyContainer}>
        <div>{company.title}</div>
        <div className={styles.companySensorCountContainer}>
          <div>Транспортных средств: {units.length} шт.</div>
          <div>Датчиков отвала: {dumpCount} шт.</div>
          <div>Датчиков посыпки: {sandCount} шт.</div>
        </div>

        <WinterMaintenceUnitsTable units={units} />
      </div>
    );
  }

  setComponentRef = (ref) => {
    this.componentRef = ref;
  };

  reactToPrintContent = () => {
    return this.componentRef;
  };

  reactToPrintTrigger = () => {
    return (
      <div style={{ width: "180px", marginBottom: "10px" }}>
        <ButtonPrimary>
          <PrintIcon /> <span>На печать</span>
        </ButtonPrimary>
      </div>
    );
  };

  downloadShorEOSKReport() {
    const {
      winterAreas,
      winterWithoutGroupsFilter,
      winterAreasFilter,
      winterGroupsFilter,
      onWinterShortEOSKReportDownload,
      searchGeoZone,
      winterSensorsFilter,
      regionTitle,
    } = this.props;

    const options = {
      searchGeoZone,
      withTable: true,
      regionTitle,
      sensorFilter: {
        dump1: winterSensorsFilter.filterDump1,
        dump2: winterSensorsFilter.filterDump2,
        sand: winterSensorsFilter.filterSand,
      },
      winterGroupFilter: {
        withoutGroups: winterWithoutGroupsFilter,
        groups: winterGroupsFilter,
      },
      winterAreaFilters: winterAreas.map((area) => {
        const winterAreaFilter = winterAreasFilter.filter((x) => {
          return x.winterAreaId === area.id;
        })[0];

        return {
          id: area.id,
          regionId: winterAreaFilter.regionId,
          parentCompanies: area.parentCompanies.map((parentCompany) => {
            return {
              id: parentCompany.id,
              winterCompanies: parentCompany.companies
                .filter((company) => {
                  return winterAreaFilter.companyId === null || winterAreaFilter.companyId === company.id;
                })
                .map((company) => {
                  return company.id;
                }),
            };
          }),
        };
      }),
    };

    onWinterShortEOSKReportDownload(options);
  }

  render() {
    const { openCompaniesInfoState, winterAreas } = this.props;

    if (openCompaniesInfoState !== 1) {
      return null;
    }

    return (
      <div className={styles.winterMaintenceCompaniesInfoContainer}>
        <div style={{ display: "flex" }}>
          <ReactToPrint
            content={this.reactToPrintContent}
            documentTitle="Списки компаний и их ТС зимнего содержания дорог"
            removeAfterPrint
            trigger={this.reactToPrintTrigger}
          />

          <div>
            <ButtonIconWrapper type={"primary"} icon="save" handleClick={this.downloadShorEOSKReport.bind(this)} />
          </div>
        </div>

        <div>
          <Scrollbars ref="scrollbar" style={{ height: "calc(100vh - 155px)" }} autoHide={false}>
            <div ref={this.setComponentRef}>
              {winterAreas.map((area) => {
                return this.areaBox(area);
              })}
            </div>
          </Scrollbars>
        </div>
      </div>
    );
  }
}

export default withWinterMaintence(React.memo(WinterMaintenceCompaniesInfo));
